import { constants } from "@newsela/angelou";
const { ui } = constants.colors;

export const AssignSplitMenuCss = {
  backgroundColor: ui.white[500],
  margin: 0,
  padding: 0,
  textIndent: 0,
  "a, button": {
    padding: "6px 16px",
    textAlign: "left",
    width: "175px",
    backgroundColor: ui.white[500],
  },
};

export const AssignmentRowTextCss = {
  margin: 0,
};

export const AssignmentRowContentCss = {
  paddingLeft: "1em",
};

export const AssignmentDateCss = { root: { textTransform: "none" } };

export const AssignMenuItemListReset = {
  margin: 0,
  padding: 0,
  textIndent: 0,
  listStyleType: "none",
};
